import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef, IconSpecificStyles } from './types';

export const Order: IconDef = {
  svg: (
    <G>
      <Path
        strokeLinecap="round"
        strokeWidth={2}
        d="M14 11H8M10 15H8M16 7H8M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z"
      />
    </G>
  ),
  svgStyles(color): IconSpecificStyles {
    return {
      stroke: color,
    };
  },
};
